class DatafeedUtils {
  static init(){
    for(const fullDatafeedDownloadBtn of document.querySelectorAll('.full-datafeed-download')){
      fullDatafeedDownloadBtn.addEventListener('click', (event)=>{
        event.preventDefault();
  
        if(!baseCustomerReportData.customerNo.length){
          alert('Please login and try again.');
          return;
        }
        
        const url = `https://${baseUrl}/api/WorldWideDataFeedWebServices/fulldatafeed`;
        const data = DatafeedUtils.getBaseData();
        DatafeedUtils.postToUrl(url, data);        
      })
    }

    for(const genericPriceListdownloadBtn of document.querySelectorAll('.generic-priceList-download')){
      genericPriceListdownloadBtn.addEventListener('click', event=>{      
        event.preventDefault();

        if(!baseCustomerReportData.customerNo.length){
          alert('Please login and try again.');
          return;
        }
        
        const url = `https://${baseUrl}/api/WorldWideDataFeedWebServices/GenericPriceList`;
        const data = DatafeedUtils.getBaseData();
        DatafeedUtils.postToUrl(url, data); 
        
        
      });
    }

    for (const bespokePriceListDownloadBtn of document.querySelectorAll('.bespoke-priceList-download')) {
      bespokePriceListDownloadBtn.addEventListener('click', event=>{
        event.preventDefault();
        if(!baseCustomerReportData.customerNo.length){
          alert('Please login and try again.');
          return;
        }
        
        const url = `https://${baseUrl}/api/WorldWideDataFeedWebServices/BespokePriceList`;
        const data = DatafeedUtils.getBaseData();
        DatafeedUtils.postToUrl(url, data); 
      })
    }
  }

  static getBaseData=()=>{
    return {
      customerNo: baseCustomerReportData.customerNo,
      customerKey: baseCustomerReportData.customerKey,
      shopifyUserId: baseCustomerReportData.shopifyUserId,
      location: baseCustomerReportData.location,
      company: baseCustomerReportData.company
    };
  }
  static postToUrl(path, params, method) {
        method = method || "post";

        var form = document.createElement("form");
        form.setAttribute("method", method);
        form.setAttribute("action", path);

        for(var key in params) {
            if(params.hasOwnProperty(key)) {
                var hiddenField = document.createElement("input");
                hiddenField.setAttribute("type", "hidden");
                hiddenField.setAttribute("name", key);
                hiddenField.setAttribute("value", params[key]);

                form.appendChild(hiddenField);
             }
        }

        document.body.appendChild(form);
        form.submit();
    }
  
}
(()=>DatafeedUtils.init())()